import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import MbCheckbox from 'components/atoms/MbCheckbox';

const NewCheckbox = (props) => {
  const { label, name, onChange = (f) => f, checked = false, style } = props;
  return (
    <FormControlLabel
      control={<MbCheckbox name={name} onChange={onChange} checked={checked} />}
      label={label}
      style={{ marginLeft: 0, marginRight: 5, ...style }}
    />
  );
};
export default NewCheckbox;
